import type { CarFleetViewRecord } from '@navio/nsdk';

export const getManagedCarsByOrganizationAndUser = (cars: CarFleetViewRecord[], organizationIds: number[]) => {
  const result = new Map<string, CarFleetViewRecord[]>();
  const includedOrganizationIds = new Set(organizationIds);

  for (const car of cars) {
    for (const owner of car.ownersCurrent ?? []) {
      const organizationId = owner.userGroup.id;
      if (!includedOrganizationIds.has(organizationId)) {
        continue;
      }
      for (const manager of car.carManagers ?? []) {
        const key = getManagedCarsKey(organizationId, manager.userId);
        result.set(key, [...(result.get(key) ?? []), car]);
      }
    }
  }

  return result;
};

export const getManagedCarsKey = (organizationId: number, userId: number) => `${organizationId}:${userId}`;
